import React from 'react';
import CategoryInsights from './CategoryInsights';

const IndustryAnalysis = () => {
  return (
    <CategoryInsights
      category="industry-analysis"
      titleKey="pages.industryAnalysis.title"
      subtitleKey="pages.industryAnalysis.subtitle"
      categoryLabelKey="insights.industryAnalysis"
    />
  );
};

export default IndustryAnalysis;
